<template>
	<div>
		<div class="offcanvas-header d-flex justify-content-between align-items-center">
			<h3 class="offcanvas-title">Корзина</h3>
			<button class="close" type="button" data-dismiss="offcanvas" aria-label="Close"><span aria-hidden="true">&times;</span></button>
		</div>
		<div class="offcanvas-body">
			<div class="offcanvas-body-inner">
				<div class="text-right"><a class="text-danger btn-sm pr-0" href="#" v-on:click="clearCart"><i class="mr-1" data-feather="x" style="width: .85rem; height: .85rem;"></i>Очистить корзину</a></div>
				<div class="widget widget-featured-entries pt-3">
					<div class="mb-4" v-for="product in cartProducts">
						<div class="media">
							<div class="featured-entry-thumb mr-3">
								<a :href="product.url">
									<img :src="getResizedPhoto(product.id)" :alt="product.productName">
								</a>
								<span class="item-remove-btn" v-on:click="removeProductFromCart(product.id)">
									<i class="fa fa-times" data-toggle="tooltip" data-placement="top" title="Удалить"></i>
								</span>
							</div>
							<div class="media-body">
								<h6 class="featured-entry-title d-flex justify-content-between flex-row"><a :href="product.url">{{product.productName}}</a><span class="text-muted font-size-sm">Артикул: {{product.code}}</span></h6>
								<p class="featured-entry-meta">{{product.count}} <span class='text-muted'>x</span> {{product.price}} ₽</p>
							</div>
						</div>
					</div>
					<hr>
					<div class="d-flex justify-content-between align-items-center py-3">
						<div class="font-size-sm">
							<span class="mr-2">Итого:</span>
							<span class="font-weight-semibold text-dark">{{totalSum}} ₽</span>
						</div>
						<a class="btn btn-outline-secondary btn-sm" href="/Order/Cart">
							Перейти в корзину<i class="mr-n2" data-feather="chevron-right"></i>
						</a>
					</div><a class="btn btn-primary btn-sm btn-block" href="/Order/Checkout"><i class="mr-1" data-feather="credit-card"></i>Заказать</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { actions, getters, namespace } from "Cart/store/store";
	import { mapGetters, mapActions } from "vuex";

	export default {
		name: "cart-widget",
		data() {
			return {
				token: "",
				products: new Array()
			};
		},
		computed: {
			...mapGetters(namespace, {
				totalSum: getters.totalSum.name,
				cartProducts: getters.cartProducts.name
			})
		},
		methods: {
			...mapActions(namespace, {
				clearCart: actions.clearCart.name,
				removeProductFromCart: actions.removeProductFromCart.name,
				updateProductCount: actions.updateProductCount.name
			}),
			getResizedPhoto(id) {
				let product = this.cartProducts.find(product => product.id === id);
				return `${product.photo}?height=100`;
			}
		}
	};
</script>